import React, { useRef, useState } from 'react';
import SignatureCanvas from 'react-signature-canvas';

import './SignaturePad.css'; // Optional für Styling


const SignaturePad = ({ onSave, onClear }) => {
    const sigCanvasRef = useRef(null);
    const [isSigned, setIsSigned] = useState(false);

    const handleClear = () => {
        sigCanvasRef.current?.clear();
        setIsSigned(false);
        onClear?.();
    };

    const handleSave = () => {
        if (!sigCanvasRef.current) return;
        const signatureData = sigCanvasRef.current.toDataURL('image/png');
        setIsSigned(true);
        onSave?.(signatureData);
    };

    return (
        <div className="signature-pad-container">
            <div className="signature-canvas-wrapper">
                <SignatureCanvas
                    ref={sigCanvasRef}
                    penColor="black"
                    canvasProps={{
                        width: 500,
                        height: 200,
                        className: 'signature-canvas',
                    }}
                    onEnd={() => setIsSigned(true)}
                />
            </div>

            <div className="signature-controls">
                <button
                    onClick={handleClear}
                    disabled={!isSigned}
                    className="clear-button"
                >
                    Unterschrift löschen
                </button>

                <button
                    onClick={handleSave}
                    disabled={!isSigned}
                    className="save-button"
                >
                    Unterschrift speichern
                </button>
            </div>

            {isSigned && (
                <div className="signature-preview">
                    <h4>Vorschau:</h4>
                    <img
                        src={sigCanvasRef.current?.toDataURL('image/png')}
                        alt="Unterschrift Vorschau"
                        className="preview-image"
                    />
                </div>
            )}
        </div>
    );
};

export default SignaturePad;